<template>
  <div v-if="isShow" class="list-box">
    <div class="componentclose" @click="isShow = false">X</div>
    <companyOchart ref="companyOchart" height="100%" />
  </div>
</template>
<script>
import companyOchart from '../ochart/companyOchart'

export default {
  components: { companyOchart },
  data() {
    return {
      isShow: false,
    }
  },
  watch: {
    $route(to, from) {
      this.close()
    },
  },
  methods: {
    open(companyName) {
      this.isShow = true
      this.$nextTick(_ => {
        this.$refs.companyOchart.open({ companyName: companyName })
      })
    },
    show(companyName) {
      this.isShow = true
      this.$nextTick(_ => {
        this.$refs.companyOchart.open({ companyName: companyName })
      })
    },
    close() {
      this.isShow = false
    },
  },
}
</script>
<style scpoed>
.list-box {
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 30;
  padding-bottom: 10px;
  width: 100vw;
  background-color: #fff;
  height: calc(100% - 60px);
}
.componentclose {
  position: absolute;
  top: 15px;
  right: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  background-color: #e83939;
  border-radius: 50%;
  z-index: 1;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2), 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px -2px rgba(0, 0, 0, 0.12);
}
</style>
